import { useCallback, useMemo, useState } from "react";
import { parseDirectiveEnvelope } from "duck/ui/chat/directiveEnvelope";

export const useHumanMessageContent = (content: string) => {
  const segments = useMemo(() => parseDirectiveEnvelope(content), [content]);
  const [expandedIndexes, setExpandedIndexes] = useState<ReadonlySet<number>>(
    new Set()
  );

  const toggleSegment = useCallback((index: number) => {
    setExpandedIndexes((previous) => {
      const next = new Set(previous);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }

      return next;
    });
  }, []);

  return {
    expandedIndexes,
    hasDirectives: segments.some((segment) => segment.type === "directive"),
    segments,
    toggleSegment,
  };
};
